import {
  IonButton,
  IonCard,
  IonCardContent,
  IonCol,
  IonContent,
  IonHeader,
  IonIcon,
  IonInput,
  IonItem,
  IonModal,
  IonRow,
  IonSpinner,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import {
  chevronBackOutline,
  chevronForwardOutline,
  closeCircleOutline,
  search,
  searchOutline,
} from "ionicons/icons";
//@ts-ignore
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import CustomDesplegable from "../../components/CustomDesplegable/CustomDesplegable";
import StyledButton from "../../components/StyledButton/StyledButton";
import {
  DesplegableModel,
  FechaFeriado,
  Paciente,
  Prestador,
  SesionAgenda,
  Turno,
} from "../../interfaces";

import ModalCalendarioPicker from "../../components/Modales/ModalCalendarioPicker";
import { COLORS } from "../../constants/app";
import http from "../../hooks/httpAdapter";
import { useSession } from "../../hooks/SessionContext";
import useTituloPagina from "../../hooks/tituloPagina";
import { useAgenda } from "../../hooks/useAgenda";
import { useTurnosCancelacion } from "../../hooks/useTurnosCancelacion";
import { obtenerIndiceArrayFechasTurnosString } from "../../utils/funcionalidadesArrays";
import {
  borrarObjetosDuplicados,
  obtenerIndiceArrayFechasTurnos,
  obtenerNombreDia,
} from "../../utils/funcionalidadesIndex";
import { obtenerFotoPrestador } from "../../utils/prestadorFotos";

interface ContainerProps {}

const obtenerSiguienteFechaConTurnosAgendados = (
  fechasOrdenadas: string[],
  agenda: Turno[],
  fechaInicial?: string,
) => {
  if (fechasOrdenadas.length === 0) return "";

  const indiceInicial = fechaInicial
    ? Math.max(
        obtenerIndiceArrayFechasTurnosString(fechasOrdenadas, fechaInicial),
        0,
      )
    : 0;

  for (let index = indiceInicial; index < fechasOrdenadas.length; index++) {
    const fecha = fechasOrdenadas[index];
    const turnosDelDia = agenda.filter(
      (turno) => dayjs(turno.fecha).unix() === dayjs(fecha).unix(),
    );

    const tieneTurnosAgendados = turnosDelDia.some(
      (turno) => !turno.cancelado && !turno.libre && turno.paciente !== 0,
    );

    if (tieneTurnosAgendados) {
      return fecha;
    }
  }

  return fechaInicial || fechasOrdenadas[indiceInicial] || fechasOrdenadas[0];
};

//@ts-ignore
const Agenda: React.FC<ContainerProps> = () => {
  const [prestadoresDesplegables, setPrestadoresDesplegable] = useState<
    DesplegableModel[]
  >([]);
  const [prestadorSeleccionado, setPrestadorSeleccionado] = useState<Prestador>(
    {
      especialidadNom: "",
      prestadorCod: 0,
      prestadorNom: "",
    },
  );
  const [fechaSelect, setFechaSelect] = useState<DesplegableModel>({
    codigo: dayjs().unix(),
    text: `${obtenerNombreDia(dayjs().format("dddd"))} ${dayjs().format("DD")} de ${dayjs().format("MMMM, YYYY")}`,
    nota: "",
  });
  const [fechasDisponibles, setFechasDisponibles] = useState<
    DesplegableModel[]
  >([]);
  const [fechaSeleccionada, setFechaSeleccionada] = useState<string>("");
  const [fechasDisponiblesString, setFechasDisponiblesString] = useState<
    string[]
  >([]);
  const {
    turnos,
    setTurnos,
    cargando: cargandoAgenda,
    traerTurnos,
    cancelarTurno: cancelarTurnoApi,
  } = useAgenda();
  const {
    cancelandoTurno,
    progresoCancelacion,
    cancelarTurnos: cancelarTurnosMasivo,
  } = useTurnosCancelacion();
  const [openPrestadorSelect, setOpenPrestadorSelect] = useState(false);
  const [openFechaSelect, setOpenFechaSelect] = useState(false);
  const [disabledPrevFecha, setDisabledPrevFecha] = useState(true);
  const [disabledSigFecha, setDisabledSigFecha] = useState(true);

  // NUEVOS ESTADOS - Para modal de turno libre (requerimiento cliente):
  const [turnoLibreSeleccionado, setTurnoLibreSeleccionado] =
    useState<Turno | null>(null);
  const [mostrarModalTurnoLibre, setMostrarModalTurnoLibre] = useState(false);

  // NUEVOS ESTADOS - Para cancelación de turnos:
  const [turnoCancelarSeleccionado, setTurnoCancelarSeleccionado] =
    useState<Turno | null>(null);
  const [mostrarModalCancelar, setMostrarModalCancelar] = useState(false);

  // NUEVOS ESTADOS - Para cancelación masiva de día completo:
  const [mostrarModalCancelarDia, setMostrarModalCancelarDia] = useState(false);
  const [cancelandoDia] = useState(false);

  const { setSesionInvalida, mostrarNotificacion } = useSession();

  const {
    hcUL,
    cargandoSession,
    agendaCargada,
    setAgendaCargada,
    pacienteCargado,
    setPacienteCargado,
    setTurnoSeleccionado,
  } = useSession();
  useTituloPagina();
  const history = useHistory();

  const listarPrestadores = () => {
    let listado: DesplegableModel[] = [];
    if (hcUL !== null) {
      for (let i = 0; i < hcUL?.prestadores.length; i++) {
        listado.push({
          codigo: hcUL?.prestadores[i].prestadorCod,
          text: hcUL?.prestadores[i].prestadorNom,
          nota: hcUL?.prestadores[i].especialidadNom,
          imageSrc: obtenerFotoPrestador(hcUL?.prestadores[i]),
        });
      }
      setPrestadoresDesplegable(listado);
    }
  };

  const prestadorSeleccionadoFoto = obtenerFotoPrestador(prestadorSeleccionado);

  const traerTurnosAgenda = async (
    prestador: Prestador,
    fechaASeleccionar?: DesplegableModel | string,
  ) => {
    let agenda: Turno[] = [];

    let fechasString: string[] = [];
    let fechaSelString = "";
    let fechasDesplegable: DesplegableModel[] = [];
    let fechaSelDesplegable: DesplegableModel = {
      codigo: dayjs().unix(),
      text: `${obtenerNombreDia(dayjs().format("dddd"))} ${dayjs().format("DD")} de ${dayjs().format("MMMM, YYYY")}`,
      nota: "",
    };

    let fechasTurnos: FechaFeriado[] = [];

    if (prestador) {
      try {
        const fechaDesde = dayjs()
          .subtract(1, "years")
          .format("YYYY/MM/DD hh:mm");
        const fechaHasta = dayjs().add(3, "month").format("YYYY/MM/DD hh:mm");

        agenda = (await traerTurnos(
          prestador,
          fechaDesde,
          fechaHasta,
        )) as Turno[];

        if (agenda.length === 0) {
          setFechaSelect(fechaSelDesplegable);
          setFechasDisponibles(fechasDesplegable);
          setFechaSeleccionada(fechaSelString);
          setFechasDisponiblesString(fechasString);
          setPrestadorSeleccionado(prestador);
          return;
        }

        agenda.filter(
          (turno) =>
            turno.especialidadNom === prestador.especialidadNom &&
            turno.prestadorCod === prestador.prestadorCod &&
            turno.prestadorNom === prestador.prestadorNom,
        );

        const fechasAgendaOrdenadas = borrarObjetosDuplicados(
          agenda,
          "fecha",
          true,
        ).sort(
          (fechaA: string, fechaB: string) =>
            dayjs(fechaA).unix() - dayjs(fechaB).unix(),
        );

        fechasAgendaOrdenadas.forEach((turno: any) => {
          fechasTurnos.push({ fecha: turno, esFeriado: false });
        });

        if (
          typeof fechaASeleccionar === "string" ||
          fechaASeleccionar === undefined
        ) {
          const fechasFuturas = fechasTurnos.map((fecha) => fecha.fecha);
          const fechaSeleccionadaString =
            typeof fechaASeleccionar === "string"
              ? fechaASeleccionar
              : undefined;

          const indiceFechaMasCercana = obtenerIndiceArrayFechasTurnosString(
            fechasFuturas,
            fechaSeleccionadaString,
          );

          const fechaBase =
            fechasFuturas[indiceFechaMasCercana] || fechasFuturas[0] || "";
          const fechaPriorizada = obtenerSiguienteFechaConTurnosAgendados(
            fechasFuturas,
            agenda,
            fechaBase,
          );

          fechasString = fechasFuturas;
          fechaSelString = fechaPriorizada;
        } else {
          let desplegableFechas: DesplegableModel[] = fechasTurnos.map(
            (fecha: FechaFeriado) => {
              return {
                codigo: dayjs(fecha.fecha).unix(),
                text: `${obtenerNombreDia(dayjs(fecha.fecha).format("dddd"))} ${dayjs(fecha.fecha).format("DD")} de ${dayjs(
                  fecha.fecha,
                ).format("MMMM, YYYY")}`,
                nota: fecha.esFeriado ? "Feriado" : "",
              };
            },
          );
          const indiceFechaMasCercana = obtenerIndiceArrayFechasTurnos(
            desplegableFechas,
            fechaASeleccionar,
          );
          fechasDesplegable = desplegableFechas;
          fechaSelDesplegable = desplegableFechas[indiceFechaMasCercana];
        }

        setFechaSelect(fechaSelDesplegable);
        setFechasDisponibles(fechasDesplegable);

        setFechaSeleccionada(fechaSelString);
        setFechasDisponiblesString(fechasString);
        setPrestadorSeleccionado(prestador);
      } catch (e) {
        // Error manejado por useAgenda
        console.error(e);
      }
    }
  };

  const handleChangeSelect = (value: any, select: string) => {
    let sesion: SesionAgenda = {
      FechaSeleccionada: fechaSelect,
      FechaSeleccionadaAnterior: agendaCargada?.FechaSeleccionada,
      PrestadorSeleccionado: prestadorSeleccionado,
    };
    switch (select) {
      case "Prestadores":
        let prestadorSelect: Prestador = {
          especialidadNom: "",
          prestadorCod: 0,
          prestadorNom: "",
        };

        hcUL?.prestadores.forEach((prestador: Prestador) => {
          if (prestador.prestadorCod === value) {
            prestadorSelect = prestador;
          }
        });

        sesion = {
          FechaSeleccionada: fechaSelect,
          PrestadorSeleccionado: prestadorSelect,
        };
        setPrestadorSeleccionado(prestadorSelect);
        break;
      case "Fecha":
        let fecha: DesplegableModel = { codigo: 0, text: "" };
        fechasDisponibles.forEach((dia: any) => {
          if (dia.codigo === value) fecha = dia;
        });

        sesion = {
          FechaSeleccionada: fecha,
          PrestadorSeleccionado: prestadorSeleccionado,
        };
        setFechaSelect(fecha);
        break;
      default:
        mostrarNotificacion(true, "Selección inválida", COLORS.ERROR);
        break;
    }
    setAgendaCargada(sesion);
  };
  const handleChangeFechaSeleccionada = (nuevaFechaseleccionada: string) => {
    setFechaSeleccionada(nuevaFechaseleccionada);

    let sesion: SesionAgenda = {
      FechaSeleccionada: nuevaFechaseleccionada,
      FechaSeleccionadaAnterior: agendaCargada?.FechaSeleccionada,
      PrestadorSeleccionado: prestadorSeleccionado,
    };

    setAgendaCargada(sesion);
  };

  const inicializarAgenda = async () => {
    listarPrestadores();

    const prestadorLogueado: Prestador = {
      prestadorCod: hcUL?.prestadorCod || 0,
      prestadorNom: hcUL?.prestadorNom || "",
      especialidadNom: hcUL?.especialidadNom || "",
    };

    const prestadorInicial =
      agendaCargada?.PrestadorSeleccionado &&
      agendaCargada.PrestadorSeleccionado.prestadorCod > 0
        ? agendaCargada.PrestadorSeleccionado
        : prestadorLogueado;

    setPacienteCargado(null);
    setTurnoSeleccionado(null);
    setPrestadorSeleccionado(prestadorInicial);
  };

  useEffect(() => {
    if (cargandoSession === false) {
      inicializarAgenda();
    }
  }, [cargandoSession]);

  useEffect(() => {
    // Solo ejecutar si el prestador es válido (no es 0 ni -1)
    if (prestadorSeleccionado.prestadorCod > 0) {
      const fechaSeleccionadaTmp: string =
        typeof agendaCargada?.FechaSeleccionada === "string"
          ? agendaCargada.FechaSeleccionada
          : typeof agendaCargada?.FechaSeleccionada === "object"
            ? dayjs
                .unix(agendaCargada.FechaSeleccionada?.codigo || 0)
                .toString()
            : dayjs().toString();

      traerTurnosAgenda(prestadorSeleccionado, fechaSeleccionadaTmp);
    }
  }, [prestadorSeleccionado]);

  useEffect(() => {}, [fechaSeleccionada]);

  const TraerPaciente = async (turno: Turno) => {
    let pacienteResponse: Paciente | null = pacienteCargado;
    try {
      const config = {
        headers: { Authorization: `Bearer ${hcUL?.token}` },
        responseEncoding: "binary",
      };
      let response = await http()
        .get(`pacientes/?documento=${turno?.pacienteDocumento}`, config)
        //@ts-ignore
        .catch((e) => {
          if (e.response && e.response.status === 401) {
            setSesionInvalida(true);
            // history.push("/", { motivoRedireccion: "401" }); // Redirección en caso de error 401
          } else {
            console.error(e);
          }
        });
      if (response.length === 1) {
        pacienteResponse = {
          codigo: response[0].codigo ?? 0,
          hc: response[0].hc ?? 0,
          documentoNro: response[0].documentoNro ?? 0,
          documentoTipo: response[0].documentoTipo ?? 0,
          documentoTipoNombre: response[0].documentoTipoNombre ?? "",
          nombre: response[0].nombre ?? "",
          apellido: response[0].apellido ?? "",
          mutual: response[0].mutual ?? 0,
          mutualNombre: response[0].mutualNombre ?? "",
          telefono: response[0].telefono ?? "",
          celular: response[0].celular ?? "",
          email: response[0].email ?? "",
          sexo: response[0].sexo ?? "",
          mutualAfiliado: response[0].mutualAfiliado ?? "",
          nacimiento: response[0].nacimiento ?? "",
          password: response[0].password ?? "",
        };
        setPacienteCargado(pacienteResponse);
      }
    } catch (e) {
      //@ts-ignore
      mostrarNotificacion(true, "Error: " + e, "rojo");
    }
  };

  const esLaFechaMasCercana = (fecha: string): boolean => {
    let fechaSeleccionadaActual: string =
      typeof agendaCargada?.FechaSeleccionada === "string"
        ? agendaCargada.FechaSeleccionada
        : dayjs.unix(agendaCargada?.FechaSeleccionada?.codigo || 0).toString();

    let fechaActual: string = dayjs().toString();

    return (
      obtenerIndiceArrayFechasTurnosString(
        fechasDisponiblesString,
        fechaSeleccionadaActual,
      ) ===
      obtenerIndiceArrayFechasTurnosString(fechasDisponiblesString, fechaActual)
    );
  };

  const handleClickBotonFecha = (signo: string) => {
    let fechaSel: string = fechaSeleccionada;
    let indice: number = obtenerIndiceArrayFechasTurnosString(
      fechasDisponiblesString,
      fechaSel,
    );
    if (signo === "+") fechaSel = fechasDisponiblesString[indice + 1];
    if (signo === "-") fechaSel = fechasDisponiblesString[indice - 1];
    if (signo === "Ant Fecha") {
      fechaSel =
        typeof agendaCargada?.FechaSeleccionadaAnterior === "string"
          ? agendaCargada.FechaSeleccionadaAnterior
          : dayjs
              .unix(agendaCargada?.FechaSeleccionadaAnterior?.codigo || 0)
              .toString();
    }
    if (signo === "Dia actual") {
      let fechasString = fechasDisponiblesString;
      let fechaSelString =
        fechasString[
          obtenerIndiceArrayFechasTurnosString(
            fechasString,
            dayjs().unix().toString(),
          )
        ];
      fechaSel = fechaSelString;
    }

    handleChangeFechaSeleccionada(fechaSel);
  };

  useEffect(() => {
    if (fechasDisponiblesString.length !== 0) {
      const currentIndex = fechasDisponiblesString.findIndex(
        (fecha) => dayjs(fecha).unix() === dayjs(fechaSeleccionada).unix(),
      );
      setDisabledPrevFecha(currentIndex === 0);
      setDisabledSigFecha(currentIndex === fechasDisponibles.length - 1);
    }
  }, [fechasDisponiblesString, fechaSeleccionada]);

  const handleClickMostrarFichaPacienteTurnoSeleccionado = async (
    turno: Turno,
  ) => {
    if (turno.paciente !== 0) {
      setTurnoSeleccionado(turno);
      await TraerPaciente(turno);
      setAgendaCargada({
        FechaSeleccionada: fechaSeleccionada,
        FechaSeleccionadaAnterior: agendaCargada?.FechaSeleccionada,
        PrestadorSeleccionado: {
          prestadorCod: hcUL?.prestadorCod || 0,
          prestadorNom: hcUL?.prestadorNom || "",
          especialidadNom: hcUL?.especialidadNom || "",
        },
      });
      history.push("/portal/Paciente");
    }
  };

  // NUEVAS FUNCIONES - Para modal de turno libre (requerimiento cliente):
  const handleClickTurnoLibre = (turno: Turno) => {
    setTurnoLibreSeleccionado(turno);
    setMostrarModalTurnoLibre(true);
  };

  const handleReservarTurno = () => {
    setMostrarModalTurnoLibre(false);
    // Redirigir a DarTurno con el turno seleccionado
    if (turnoLibreSeleccionado) {
      setTurnoSeleccionado(turnoLibreSeleccionado);
      setAgendaCargada({
        FechaSeleccionada: fechaSeleccionada,
        FechaSeleccionadaAnterior: agendaCargada?.FechaSeleccionada,
        PrestadorSeleccionado: {
          prestadorCod: hcUL?.prestadorCod || 0,
          prestadorNom: hcUL?.prestadorNom || "",
          especialidadNom: hcUL?.especialidadNom || "",
        },
      });
      history.push("/portal/DarTurno");
    }
  };

  const handleGenerarTurno = () => {
    setMostrarModalTurnoLibre(false);
    if (turnoLibreSeleccionado) {
      const turnoPlantilla: Turno = {
        ...turnoLibreSeleccionado,
        codigo: 0, // Sin código para indicar que es nuevo
        paciente: 0,
        pacienteNom: "",
        pacienteDocumento: 0,
        libre: true,
      };
      setTurnoSeleccionado(turnoPlantilla);
      setAgendaCargada({
        FechaSeleccionada: fechaSeleccionada,
        FechaSeleccionadaAnterior: agendaCargada?.FechaSeleccionada,
        PrestadorSeleccionado: {
          prestadorCod: hcUL?.prestadorCod || 0,
          prestadorNom: hcUL?.prestadorNom || "",
          especialidadNom: hcUL?.especialidadNom || "",
        },
      });
    }
    // Redirigir a página de nuevo turno
    history.push("/portal/Nuevo%20Turno");
  };

  // Para cancelación de turnos:
  const handleClickCancelarTurno = (turno: Turno, event: React.MouseEvent) => {
    event.stopPropagation(); // Evitar que se ejecute el click del turno
    setTurnoCancelarSeleccionado(turno);
    setMostrarModalCancelar(true);
  };

  const confirmarCancelacionTurno = async () => {
    if (!turnoCancelarSeleccionado) return;

    try {
      await cancelarTurnoApi(turnoCancelarSeleccionado.codigo);

      // Refrescar la agenda automáticamente
      await traerTurnosAgenda(prestadorSeleccionado, fechaSeleccionada);
    } catch (e) {
      // Error manejado por useAgenda
      console.error(e);
    } finally {
      setMostrarModalCancelar(false);
      setTurnoCancelarSeleccionado(null);
    }
  };

  // Para cancelación masiva de día completo:
  const obtenerTurnosOcupadosDelDia = () => {
    return turnos.filter(
      (turno) =>
        dayjs(turno.fecha).unix() === dayjs(fechaSeleccionada).unix() &&
        !turno.libre &&
        !turno.cancelado &&
        turno.paciente !== 0,
    );
  };

  const handleClickCancelarDia = () => {
    const turnosOcupados = obtenerTurnosOcupadosDelDia();
    if (turnosOcupados.length === 0) {
      mostrarNotificacion(
        true,
        "No hay turnos ocupados para cancelar en este día",
        COLORS.WARNING,
      );
      return;
    }
    setMostrarModalCancelarDia(true);
  };

  const confirmarCancelacionDia = async () => {
    const turnosACancelar = obtenerTurnosOcupadosDelDia();
    if (turnosACancelar.length === 0) return;

    try {
      const { exitosos, errores } = await cancelarTurnosMasivo(
        turnosACancelar,
        (codigo) => cancelarTurnoApi(codigo),
      );

      // Mostrar resultado
      if (errores === 0) {
        mostrarNotificacion(
          true,
          `Se cancelaron exitosamente ${exitosos} turnos del día`,
          COLORS.SUCCESS,
        );
      } else {
        mostrarNotificacion(
          true,
          `Se cancelaron ${exitosos} turnos. ${errores} turnos no pudieron cancelarse.`,
          COLORS.WARNING,
        );
      }

      // Refrescar la agenda automáticamente
      await traerTurnosAgenda(prestadorSeleccionado, fechaSeleccionada);
    } catch (e) {
      console.error(e);
    } finally {
      setMostrarModalCancelarDia(false);
    }
  };

  const renderAgenda = () => {
    const mostrarAgenda = turnos
      .filter(
        (turno) =>
          dayjs(turno.fecha).unix() === dayjs(fechaSeleccionada).unix(),
      )
      .map((turno) => {
        return (
          <IonItem
            key={turno.codigo}
            // NUEVA LÓGICA - Turnos cancelados no son clickeables, otros sí:
            button={!turno.cancelado}
            onClick={() => {
              if (turno.cancelado) return; // No hacer nada si está cancelado
              turno.libre
                ? handleClickTurnoLibre(turno)
                : handleClickMostrarFichaPacienteTurnoSeleccionado(turno);
            }}
          >
            <IonCol sizeXs="3" sizeMd="2">
              <StyledButton
                disabled
                className={
                  // NUEVA LÓGICA - Incluye manejo de turnos cancelados:
                  turno.cancelado
                    ? "cancelado text" // Turnos cancelados tachados
                    : turno.libre
                      ? "gris text" // Turnos libres en gris
                      : !turno.asistio
                        ? turno.paciente !== 0
                          ? "blanco text"
                          : "blanco text"
                        : dayjs(turno.atendidoHora).format("HH:mm") !==
                            dayjs("0001-01-01T00:00:00").format("HH:mm")
                          ? "verde text"
                          : "rojo text"
                }
              >
                <small>
                  {/* NUEVA LÓGICA - Incluye manejo de turnos cancelados: */}
                  {turno.cancelado
                    ? "Cancelado"
                    : turno.libre
                      ? "Libre"
                      : !turno.asistio
                        ? turno.paciente !== 0
                          ? "No asistio"
                          : "No asignado"
                        : dayjs(turno.atendidoHora).format("HH:mm") !==
                            dayjs("0001-01-01T00:00:00").format("HH:mm")
                          ? "Atendido"
                          : "Asistio"}
                </small>
              </StyledButton>
            </IonCol>
            <IonCol sizeXs="2" sizeMd="1.5">
              <small>{dayjs(turno.hora).format("HH:mm")}</small>
            </IonCol>
            <IonCol sizeXs="5" sizeMd="3">
              <small>
                {/* NUEVA LÓGICA - Manejo de turnos cancelados y libres: */}
                {turno.cancelado
                  ? ""
                  : turno.libre
                    ? ""
                    : turno.pacienteNom === ""
                      ? ""
                      : turno.pacienteNom}
              </small>
            </IonCol>
            <IonCol sizeMd="2.5" className="agenda-col-mutual">
              <small>
                {/* NUEVA LÓGICA - Manejo de turnos cancelados y libres: */}
                {turno.cancelado
                  ? ""
                  : turno.libre
                    ? ""
                    : turno.mutualNom === ""
                      ? ""
                      : turno.mutualNom}
              </small>
            </IonCol>
            <IonCol sizeMd="2" className="agenda-col-observacion">
              <small>
                {/* NUEVA LÓGICA - Manejo de turnos cancelados y libres: */}
                {turno.libre
                  ? ""
                  : turno.observaciones &&
                    ("" + turno.observaciones).toLowerCase().substring(0, 35) +
                      (("" + turno.observaciones).length > 35 ? "..." : "")}
              </small>
            </IonCol>
            {/* NUEVO ÍCONO DE CANCELACIÓN - Solo visible en turnos ocupados no cancelados */}
            <IonCol sizeXs="2" sizeMd="1">
              {!turno.libre && !turno.cancelado && turno.paciente !== 0 && (
                <IonButton
                  fill="clear"
                  size="small"
                  color="danger"
                  onClick={(e) => handleClickCancelarTurno(turno, e)}
                >
                  <IonIcon icon={closeCircleOutline} />
                </IonButton>
              )}
            </IonCol>
          </IonItem>
        );
      });
    return mostrarAgenda;
  };

  return (
    <>
      <IonCard>
        <IonRow>
          <IonCol sizeXs="12" sizeMd="6">
            <IonItem>
              <IonInput
                readonly
                label="Prestador"
                label-placement="floating"
                id="prestador"
                value={prestadorSeleccionado.prestadorNom}
                onClick={() => setOpenPrestadorSelect(true)}
              />
              <IonButton
                slot="end"
                fill="clear"
                onClick={() => setOpenPrestadorSelect(true)}
              >
                <IonIcon
                  aria-hidden="true"
                  ios={searchOutline}
                  md={search}
                  size="large"
                />
              </IonButton>
            </IonItem>
            {prestadorSeleccionadoFoto && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  padding: "12px 16px 0 16px",
                }}
              >
                <img
                  src={prestadorSeleccionadoFoto}
                  alt={prestadorSeleccionado.prestadorNom}
                  className="prestador-avatar prestador-avatar--selected"
                />
                <div>
                  <strong>{prestadorSeleccionado.prestadorNom}</strong>
                  <div style={{ fontSize: "0.9rem", opacity: 0.8 }}>
                    {prestadorSeleccionado.especialidadNom}
                  </div>
                </div>
              </div>
            )}
          </IonCol>
          {turnos.length !== 0 && (
            <IonCol sizeXs="12" sizeMd="6">
              <IonRow>
                <IonButton
                  color="dark"
                  onClick={() => handleClickBotonFecha("-")}
                  disabled={disabledPrevFecha}
                  expand="block"
                  fill="clear"
                >
                  <IonIcon icon={chevronBackOutline} size="large" />
                </IonButton>
                <IonButton
                  color="dark"
                  onClick={() => handleClickBotonFecha("+")}
                  disabled={disabledSigFecha}
                  expand="block"
                  fill="clear"
                >
                  <IonIcon icon={chevronForwardOutline} size="large" />
                </IonButton>

                <ModalCalendarioPicker
                  fechasFuturas={fechasDisponiblesString}
                  fechaSeleccionada={fechaSeleccionada}
                  handleChangeFecha={handleChangeFechaSeleccionada}
                />
                <IonButton
                  color={
                    esLaFechaMasCercana(fechaSeleccionada) ? "dark" : "warning"
                  }
                  onClick={() =>
                    handleClickBotonFecha(
                      esLaFechaMasCercana(fechaSeleccionada)
                        ? "Ant Fecha"
                        : "Dia actual",
                    )
                  }
                  disabled={!agendaCargada?.FechaSeleccionadaAnterior}
                  expand="block"
                  fill={
                    esLaFechaMasCercana(fechaSeleccionada) ? "clear" : "solid"
                  }
                >
                  {esLaFechaMasCercana(fechaSeleccionada)
                    ? "Ant Fecha"
                    : "Dia actual"}
                  {/* {dayjs().unix(agendaCargada?.FechaSeleccionada) ? "Hoy" : "Ant"} */}
                </IonButton>

                {/* NUEVO BOTÓN - Cancelación masiva de día completo */}
                {obtenerTurnosOcupadosDelDia().length > 0 && (
                  <IonButton
                    color="danger"
                    onClick={handleClickCancelarDia}
                    expand="block"
                    fill="outline"
                    size="small"
                  >
                    Cancelar día
                  </IonButton>
                )}
              </IonRow>
            </IonCol>
          )}
        </IonRow>
      </IonCard>
      {cargandoAgenda ? (
        <IonRow className="ion-justify-content-center">
          <IonCol>
            <IonCard>
              <IonCardContent>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "20px",
                  }}
                >
                  <IonSpinner name="crescent" />
                  <p>Cargando agenda...</p>
                </div>
              </IonCardContent>
            </IonCard>
          </IonCol>
        </IonRow>
      ) : turnos.length !== 0 ? (
        <>
          <IonItem className="fila cabecera">
            <IonCol className="celda cabecera" sizeXs="3" sizeMd="2">
              <small>Estado</small>
            </IonCol>
            <IonCol className="celda cabecera" sizeXs="2" sizeMd="1.5">
              <small>Hora</small>
            </IonCol>
            <IonCol className="celda cabecera" sizeXs="5" sizeMd="3">
              <small>Paciente</small>
            </IonCol>
            <IonCol className="celda cabecera agenda-col-mutual" sizeMd="2.5">
              <small>Mutual</small>
            </IonCol>
            <IonCol
              className="celda cabecera agenda-col-observacion"
              sizeMd="2"
            >
              <small>Observacion</small>
            </IonCol>
            <IonCol className="celda cabecera" sizeXs="2" sizeMd="1">
              <small>Acción</small>
            </IonCol>
          </IonItem>
          <>{renderAgenda()}</>
        </>
      ) : prestadorSeleccionado.prestadorCod > 0 ? (
        <IonRow className="ion-justify-content-center">
          <IonCol>
            <IonCard color="warning">
              <IonCardContent>
                <h4 className="main-content">{`No se encontraron turnos con ${prestadorSeleccionado.prestadorNom} `}</h4>
              </IonCardContent>
            </IonCard>
          </IonCol>
        </IonRow>
      ) : null}

      <CustomDesplegable
        array={prestadoresDesplegables}
        handleChange={handleChangeSelect}
        id="Prestadores"
        mostrarSearch={true}
        mostrarTodos={false}
        value={prestadorSeleccionado.prestadorCod}
        open={openPrestadorSelect}
        setOpen={setOpenPrestadorSelect}
      />

      {prestadorSeleccionado.prestadorCod !== -1 &&
        prestadorSeleccionado.prestadorCod !== 0 &&
        turnos.length !== 0 && (
          <CustomDesplegable
            id="Fecha"
            open={openFechaSelect}
            setOpen={setOpenFechaSelect}
            array={fechasDisponibles}
            value={fechaSelect.codigo}
            handleChange={handleChangeSelect}
            mostrarTodos={false}
            mostrarSearch={false}
          />
        )}

      {/* NUEVO MODAL - Para turnos libres (requerimiento cliente) */}
      <IonModal
        isOpen={mostrarModalTurnoLibre}
        onDidDismiss={() => setMostrarModalTurnoLibre(false)}
      >
        <IonHeader>
          <IonToolbar>
            <IonTitle>Turno Disponible</IonTitle>
            <IonButton
              slot="end"
              fill="clear"
              onClick={() => setMostrarModalTurnoLibre(false)}
            >
              Cerrar
            </IonButton>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <div style={{ padding: "20px" }}>
            <h3>Turno Disponible</h3>
            <div
              style={{
                backgroundColor: "var(--ion-color-light)",
                padding: "15px",
                borderRadius: "8px",
                marginBottom: "20px",
              }}
            >
              <p>
                <strong>Fecha:</strong>{" "}
                {turnoLibreSeleccionado &&
                  dayjs(turnoLibreSeleccionado.fecha).format("DD/MM/YYYY")}
              </p>
              <p>
                <strong>Hora:</strong>{" "}
                {turnoLibreSeleccionado &&
                  dayjs(turnoLibreSeleccionado.hora).format("HH:mm")}
              </p>
              <p>
                <strong>Prestador:</strong>{" "}
                {turnoLibreSeleccionado?.prestadorNom}
              </p>
              <p>
                <strong>Especialidad:</strong>{" "}
                {turnoLibreSeleccionado?.especialidadNom}
              </p>
            </div>

            <h4>¿Qué desea hacer?</h4>

            <IonButton
              expand="block"
              onClick={handleReservarTurno}
              style={{ marginBottom: "15px" }}
              color="primary"
            >
              <div style={{ textAlign: "left", width: "100%" }}>
                <div>
                  <strong>Reservar este turno</strong>
                </div>
                <small>Asignar paciente a este horario específico</small>
              </div>
            </IonButton>

            <IonButton
              expand="block"
              fill="outline"
              onClick={handleGenerarTurno}
              color="secondary"
            >
              <div style={{ textAlign: "left", width: "100%" }}>
                <div>
                  <strong>Generar nuevo turno</strong>
                </div>
                <small>
                  Crear turno para este prestador en otra fecha/hora
                </small>
              </div>
            </IonButton>
          </div>
        </IonContent>
      </IonModal>

      {/* NUEVO MODAL - Para confirmar cancelación de turno */}
      <IonModal
        isOpen={mostrarModalCancelar}
        onDidDismiss={() => setMostrarModalCancelar(false)}
      >
        <IonHeader>
          <IonToolbar>
            <IonTitle>Confirmar Cancelación</IonTitle>
            <IonButton
              slot="end"
              fill="clear"
              onClick={() => setMostrarModalCancelar(false)}
            >
              Cerrar
            </IonButton>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <div style={{ padding: "20px" }}>
            <h3>¿Está seguro que desea cancelar este turno?</h3>
            {turnoCancelarSeleccionado && (
              <>
                <p>
                  <strong>Paciente:</strong>{" "}
                  {turnoCancelarSeleccionado.pacienteNom}
                </p>
                <p>
                  <strong>Fecha:</strong>{" "}
                  {dayjs(turnoCancelarSeleccionado.fecha).format("DD/MM/YYYY")}
                </p>
                <p>
                  <strong>Hora:</strong>{" "}
                  {dayjs(turnoCancelarSeleccionado.hora).format("HH:mm")}
                </p>
                <p>
                  <strong>Prestador:</strong>{" "}
                  {turnoCancelarSeleccionado.prestadorNom}
                </p>
                <p>
                  <strong>Mutual:</strong> {turnoCancelarSeleccionado.mutualNom}
                </p>
              </>
            )}

            <div style={{ marginTop: "30px" }}>
              <IonButton
                expand="block"
                color="danger"
                onClick={confirmarCancelacionTurno}
                disabled={cancelandoTurno}
                style={{ marginBottom: "15px" }}
              >
                {cancelandoTurno ? (
                  <>
                    <IonSpinner
                      name="crescent"
                      style={{ marginRight: "10px" }}
                    />
                    Cancelando...
                  </>
                ) : (
                  "Sí, cancelar turno"
                )}
              </IonButton>

              <IonButton
                expand="block"
                fill="outline"
                onClick={() => setMostrarModalCancelar(false)}
                disabled={cancelandoTurno}
              >
                No, mantener turno
              </IonButton>
            </div>
          </div>
        </IonContent>
      </IonModal>

      {/* NUEVO MODAL - Para confirmar cancelación masiva de día completo */}
      <IonModal
        isOpen={mostrarModalCancelarDia}
        onDidDismiss={() => setMostrarModalCancelarDia(false)}
      >
        <IonHeader>
          <IonToolbar>
            <IonTitle>Cancelar Día Completo</IonTitle>
            <IonButton
              slot="end"
              fill="clear"
              onClick={() => setMostrarModalCancelarDia(false)}
            >
              Cerrar
            </IonButton>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <div style={{ padding: "20px" }}>
            <h3>
              ¿Está seguro que desea cancelar todos los turnos de este día?
            </h3>

            <div
              style={{
                marginBottom: "20px",
                padding: "15px",
                backgroundColor: "var(--ion-color-light)",
                borderRadius: "8px",
              }}
            >
              <p>
                <strong>Fecha:</strong>{" "}
                {dayjs(fechaSeleccionada).format("DD/MM/YYYY")}
              </p>
              <p>
                <strong>Prestador:</strong> {prestadorSeleccionado.prestadorNom}
              </p>
              <p>
                <strong>Turnos a cancelar:</strong>{" "}
                {obtenerTurnosOcupadosDelDia().length}
              </p>
            </div>

            {/* Lista de turnos que serán cancelados */}
            <div
              style={{
                maxHeight: "200px",
                overflowY: "auto",
                marginBottom: "20px",
              }}
            >
              <h4>Turnos que serán cancelados:</h4>
              {obtenerTurnosOcupadosDelDia().map((turno, index) => (
                <div
                  key={turno.codigo}
                  style={{
                    padding: "8px",
                    borderBottom: "1px solid var(--ion-color-step-950)",
                  }}
                >
                  <small>
                    <strong>{dayjs(turno.hora).format("HH:mm")}</strong> -{" "}
                    {turno.pacienteNom} ({turno.mutualNom})
                  </small>
                </div>
              ))}
            </div>

            {/* Indicador de progreso durante la cancelación */}
            {cancelandoDia && (
              <div style={{ marginBottom: "20px", textAlign: "center" }}>
                <IonSpinner name="crescent" />
                <p style={{ marginTop: "10px" }}>
                  Cancelando turnos... {progresoCancelacion.actual} de{" "}
                  {progresoCancelacion.total}
                </p>
                <div
                  style={{
                    width: "100%",
                    height: "8px",
                    backgroundColor: "var(--ion-color-step-900)",
                    borderRadius: "4px",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      width: `${(progresoCancelacion.actual / progresoCancelacion.total) * 100}%`,
                      height: "100%",
                      backgroundColor: "var(--ion-color-secondary)",
                      transition: "width 0.3s ease",
                    }}
                  ></div>
                </div>
              </div>
            )}

            <div style={{ marginTop: "30px" }}>
              <IonButton
                expand="block"
                color="danger"
                onClick={confirmarCancelacionDia}
                disabled={cancelandoDia}
                style={{ marginBottom: "15px" }}
              >
                {cancelandoDia
                  ? "Cancelando turnos..."
                  : `Sí, cancelar ${obtenerTurnosOcupadosDelDia().length} turnos`}
              </IonButton>

              <IonButton
                expand="block"
                fill="outline"
                onClick={() => setMostrarModalCancelarDia(false)}
                disabled={cancelandoDia}
              >
                No, mantener turnos
              </IonButton>
            </div>
          </div>
        </IonContent>
      </IonModal>
    </>
  );
};

export default Agenda;
